<app-page-hero-redesign
  [title]="'About'"
  [backgroundImage]="'assets/img/redesign/solutions/hero-page-bg.png'"
  [breadcrumbs]="[
    { label: 'Home', url: '/home-redesign' },
    { label: 'About' }
  ]">
</app-page-hero-redesign>
<app-about-intro-redesign></app-about-intro-redesign>
<app-mission-vision-redesign></app-mission-vision-redesign>
<app-content-image-redesign
    [image]="'/assets/img/redesign/about/our-story.png'"
    [imageAlt]="'Our Story'"
    [title]="'Our Story'"
    [paragraphs]="[
        'Althea Soft was founded in response to a clear problem: mental health care is often delivered through disconnected systems, delayed information and limited visibility between clinical encounters.',

        'In many institutions, each professional sees only part of the patient journey. Althea Soft was created to help close this gap by combining artificial intelligence, biometric monitoring, secure data infrastructure and clinical workflow coordination.',

        'Our work is driven by a simple principle: better information, shared at the right time with the right clinical team, can support safer and more effective mental healthcare.'
    ]">
</app-content-image-redesign>
<app-why-althea-redesign></app-why-althea-redesign>
<app-about-intro-redesign
    [title]="'Innovation & Validation'"
    [paragraphs]="[
        'Althea Soft is developing patented clinical AI technology for mental health and neurological care, focused on predictive risk detection, real-time monitoring and coordinated clinical action.',

        'The platform has been designed with a strong emphasis on privacy, security and healthcare compliance, supporting the needs of regulated clinical environments.',

        'Where appropriate, Althea Soft works with academic, technical and healthcare partners to validate its approach and strengthen the scientific and clinical foundations of its technology.'
    ]"
    [darkBackground]="true">
</app-about-intro-redesign>
<app-text-image-redesign
    [paragraphs]="[
        'Althea Soft is led by a team with experience across artificial intelligence, healthcare technology, software architecture, clinical workflow design and institutional innovation.',

        'We are united by the belief that mental healthcare needs better infrastructure — not more isolated tools.',

        'Our focus is to build technology that can be trusted by institutions, used by clinical teams and scaled across complex healthcare environments.'
    ]"
    [image]="'/assets/img/redesign/about/bigteam.png'"
    [imageAlt]="'Our Team'">
</app-text-image-redesign>
<app-contact-highlight-redesign></app-contact-highlight-redesign>
